// extracted by mini-css-extract-plugin
module.exports = {"root":"GptAd_root__nza6l"};